import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@chakra-ui/react';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (event) => {
    const language = event.target.value;
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  };

  return (
    <Select
      value={i18n.language}
      onChange={changeLanguage}
      width="auto"
      size="sm"
      bg="gray.800"
      color="white"
      borderColor="blue.500"
      _hover={{
        borderColor: 'blue.400',
        bg: 'gray.700'
      }}
      _focus={{
        borderColor: 'blue.400',
        boxShadow: '0 0 0 1px #4299E1'
      }}
    >
      <option value="en">English</option>
      <option value="zh">中文</option>
    </Select>
  );
};

export default LanguageSelector;
